/**
 * @typedef {object} LeaderboardState
 * @property {LeaderboardNavState} nav
 * @property {any} data
 * @property {LeaderboardFilter} filter
 */

/**
 * @typedef {object} LeaderboardNavState
 * @property {string} category
 * @property {object} competition
 * @property {number|null} competition.id
 * @property {object} club
 * @property {number|null} club.id
 */
